// extracted by mini-css-extract-plugin
export default {"timeline":"psoghS8ptc3_HZfkYV_8"};